import { IntegrationEntitySyncTag } from "components";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { ITableV2Column } from "components/table-v2/table-v2";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { TSmeSyncLeadSourceData } from "types/sme.type";
import { SmeLeadSourceSyncSelect } from "./SmeSourceSyncSelect";

export const syncSmeLeadSourceTableColumnDef = (
  accountStore: UserAccountStore,
  updateSyncPair: (syncPair: TSmeSyncLeadSourceData) => void
): ITableV2Column<TSmeSyncLeadSourceData>[] => {
  return [
    {
      accessor: "smeSourceName",
      disableSortBy: true,
      Header: <DefaultHeaderCell>Sme Professional Source</DefaultHeaderCell>,
      Cell: ({ row }) => <DefaultRowCell>{row.smeSourceName}</DefaultRowCell>,
    },
    {
      accessor: "leadSourceId",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>LeadPro Source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell textTransform={"capitalize"}>
          <SmeLeadSourceSyncSelect
            accountStore={accountStore}
            onChange={updateSyncPair}
            record={row}
          />
        </DefaultRowCell>
      ),
    },
    {
      accessor: "syncStatus",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>Status</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <IntegrationEntitySyncTag syncStatus={row.syncStatus} />
        </DefaultRowCell>
      ),
    },
  ];
};
